// src/components/AuthWrapper.js
import React from "react";
import { Navigate } from "react-router-dom";
import appSession from "../utils/appSession";

const AuthWrapper = ({ children, allowedRoles }) => {
  const token = appSession.getToken();

  // Check if the user is authenticated
  const isAuthenticated = !!token;

  if (token) {
    try {
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      if (decodedToken.exp && decodedToken.exp * 1000 <= Date.now()) {
        if (appSession.isImpersonating()) {
          appSession.endImpersonationSession();
          return <Navigate to="/admin" replace />;
        }

        appSession.clearAllSessions();
        return <Navigate to="/auth" replace />;
      }
    } catch {
      if (appSession.isImpersonating()) {
        appSession.endImpersonationSession();
        return <Navigate to="/admin" replace />;
      }

      appSession.clearAllSessions();
      return <Navigate to="/auth" replace />;
    }
  }

  // Decode the token to get user role (assuming you use JWT)
  const userRole = token
    ? JSON.parse(atob(token.split(".")[1])).isAdmin
    : false;

  const isAuthorized = allowedRoles.includes(userRole);

  if (!isAuthenticated) {
    return <Navigate to="/auth" />;
  }

  if (allowedRoles && !isAuthorized) {
    return <Navigate to="/unauthorized" />; // Redirect to an unauthorized page
  }

  return children;
};

export default AuthWrapper;
